import {
  CLOSE_MODAL_SUCCESS, OPEN_MODAL_SUCCESS, TFA_NOTIFICATION_SUCCESS,
} from './actionTypes';

export const showModal = (name, options) => ({
  type: OPEN_MODAL_SUCCESS,
  payload: {
    name,
    options,
  },
});

export const closeModals = () => ({
  type: CLOSE_MODAL_SUCCESS,
});

export const disableTFANotification = (email) => (
  { type: TFA_NOTIFICATION_SUCCESS, payload: email }
);
